import { createSelector } from 'reselect';

export const getCurrentPage = createSelector(
  (state) => state.projects.scenes.creation.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getCurrentStage = createSelector(
  (state) => state.projects.scenes.creation.ui.currentStage,
  (currentStage) => {
    return currentStage;
  }
);

export const getProjectForm = createSelector(
  (state) => state.projects.scenes.creation.ui.projectForm,
  (projectForm) => {
    return projectForm;
  }
);

export const getGeneralContractors = createSelector(
  (state) => state.projects.scenes.creation.data.generalContractors,
  (generalContractors) => {
    return generalContractors;
  }
);

export const getClientForm = createSelector(
  (state) => state.projects.scenes.creation.ui.clientForm,
  (clientForm) => {
    return clientForm;
  }
);

export const getShowNewClientModal = createSelector(
  (state) => state.projects.scenes.creation.ui.showNewClientModal,
  (showNewClientModal) => {
    return showNewClientModal;
  }
);

export const getBuildingForm = createSelector(
  (state) => state.projects.scenes.creation.ui.buildingForm,
  (buildingForm) => {
    return buildingForm;
  }
);

export const getShowNewBuildingModal = createSelector(
  (state) => state.projects.scenes.creation.ui.showNewBuildingModal,
  (showNewBuildingModal) => {
    return showNewBuildingModal;
  }
);

export const getNewProjectId = createSelector(
  (state) => state.projects.scenes.creation.data.newProjectId,
  (newProjectId) => {
    return newProjectId;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/store/selectors.js